export default __webpack_public_path__ + "static/media/85t.dbea06b3.jpg";